module.exports = __webpack_public_path__ + "static/media/lw.2b5c4637.png";